import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: "'Rawline', sans-serif",
    body: "'Rawline', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "#fafafa",
      },
    },
  },
});

export default theme;
